export function getPhoneNumberFormat(num: string): string {
    const clave = num.slice(0, 2)
    const first_digits = num.slice(2, 6)
    const second_digits = num.slice(6, 10)
    return `(${clave}) ${first_digits} ${second_digits}`
}